<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconExpand_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M7.53 2.195 4.195 5.528a.666.666 0 1 0 .943.943L8 3.609l2.862 2.862a.666.666 0 1 0 .943-.943L8.472 2.195a.666.666 0 0 0-.943 0Zm.941 12.053 3.333-3.333a.666.666 0 1 0-.942-.942L8 12.834 5.138 9.973a.666.666 0 1 0-.943.942l3.334 3.333c.26.26.681.26.942 0Z"
        clip-rule="evenodd"
    />
</svg>
